<template>
  <div class="charge-mgmt">
    <div class="main-title">
      <p v-if="view=='list'" @click="cancelHandle">充电桩管理</p>
      <p v-if="view=='detail'" @click="cancelHandle">充电桩管理</p>
      <p v-if="view=='detail'">>详情</p>
      <p v-if="view=='edit'" @click="cancelHandle">充电桩管理</p>
      <p v-if="view=='edit'">>编辑</p>
      <p v-if="view=='add'" @click="cancelHandle">充电桩管理</p>
      <p v-if="view=='add'">>新增</p>
    </div>
    <div class="main-body" v-if="view=='list'">
      <div class="list">
        <span>设备编号：</span>
        <el-input
          class="list-input"
          size="mini"
          v-model="searchCondition"
          placeholder="请输入设备编号/通讯板编号"
        ></el-input>
        <span class="ml10">设备名称：</span>
        <el-input class="list-input" size="mini" v-model="deviceName" placeholder="请输入设备名称"></el-input>
        <div class="blue-btn ml10" @click="onQueryBtnClick">查询</div>
        <div class="blue-btn ml10" @click="view = 'add'">新增</div>
      </div>
      <table class="table-custom">
        <thead>
        <tr>
          <th>设备编号</th>
          <th>通讯板编号</th>
          <th>设备类型</th>
          <th>设备名称</th>
          <th>定位地址</th>
          <th>投放地址</th>
          <th>设备状态</th>
          <th width="150px">操作</th>
        </tr>
        </thead>
        <tbody v-if="dataList.length>0">
        <tr v-for="item,index in dataList" :key="index">
          <td>{{ item.primaryDeviceNo }}</td>
          <td>{{ item.communicationBoardNo }}</td>
          <td>{{ item.type }}</td>
          <td>{{ item.deviceName }}</td>
          <td>{{ item.location }}</td>
          <td>{{ item.showPlacingPosition }}</td>
          <td>{{ item.enableStatus == 1 ? '启用' : (item.enableStatus == 0 ? '停用' : '') }}</td>
          <td>
            <div class="text-btn" @click="onEditBtnClick(item)">编辑</div>
            <div class="text-btn fixed-width-75" @click="onDetailBtnClick(item)">查看详情</div>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="8">暂无数据</td>
        </tr>
        </tbody>
      </table>
      <div class="page-box">
        <div class="page-count">第{{ pageIndex }}页，当前页{{ dataList.length }}条，共{{ total }}条</div>
        <div class="page-count">
          跳转到第
          <el-input v-model="page" class="page-choose fixed-width-35" size="mini"></el-input>
          页
        </div>
        <div class="page-count text-btn" @click="onPageChooseBtnClick">跳转</div>
        <div class="pre-btn" :class="preBtnDisabled?'disabled':''" @click="onPreBtnClick">上一页</div>
        <div class="next-btn" :class="nextBtnDisabled?'disabled':''" @click="onNextBtnClick">下一页</div>
      </div>
    </div>
    <div class="main-body" v-if="view == 'edit'">
      <charge-mgmt-edit-view
        :editData="editData"
        @editSuccess="editSuccessHandle"
        @cancel="cancelHandle"
      ></charge-mgmt-edit-view>
    </div>
    <div class="main-body" v-if="view == 'detail'">
      <charge-mgmt-detail-view :editData="editData" @cancel="cancelHandle"></charge-mgmt-detail-view>
    </div>
    <div class="main-body" v-if="view == 'add'">
      <charge-cabinet-mgmt-add-view @addSuccess="addSuccessHandle" @cancel="cancelHandle"
                                    :deviceType="0"></charge-cabinet-mgmt-add-view>
    </div>
  </div>
</template>

<script>
import ChargeMgmtEditView from "./chargeMgmtEditView";
import ChargeMgmtDetailView from "./chargeMgmtDetailView";
import ChargeMgmtSnapshotView from "./snapShot";
import ChargeCabinetMgmtAddView from "./chargeCabinetMgmtAddView";

export default {
  name: "chargeMgmt",
  components: {
    ChargeMgmtSnapshotView,
    ChargeMgmtDetailView,
    ChargeMgmtEditView,
    ChargeCabinetMgmtAddView
  },
  data() {
    return {
      view: "list",
      searchCondition: "",
      deviceName: "",
      pageSize: 10,
      beginIndex: 0,
      pageIndex: 1,
      page: 1,
      total: "",
      totalPage: 0,
      preBtnDisabled: true,
      nextBtnDisabled: false,
      dataList: [],
      editData: {}
    };
  },
  mounted() {
    if (this.$route.query.searchCondition) {
      this.searchCondition = this.$route.query.searchCondition;
    }
    if (this.$route.query.deviceName) {
      this.deviceName = this.$route.query.deviceName;
    }
    if (this.$route.query.beginIndex) {
      this.beginIndex = this.$route.query.beginIndex;
    }
    if (this.$route.query.primaryDeviceNo) {
      let data = {primaryDeviceNo: this.$route.query.primaryDeviceNo};
      this.onDetailBtnClick(data);
    }
    this.queryDeviceList();
  },
  methods: {
    queryDeviceList: function () {
      let self = this;
      let params = {
        searchCondition: this.searchCondition,
        deviceName: this.deviceName,
        deviceType: 0,
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1
      };
      this.$http
        .post(
          "/managementPlatform/electricity/deviceList",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message || "查询失败!",
              center: true
            });
            return;
          }
          self.dataList = res.ldata;
          self.resetPreAndNextBtn(self.dataList.length);
          self.dataList.length > self.pageSize && self.dataList.pop();
          self.page = Math.floor(self.beginIndex / self.pageSize) + 1;
          self.pageIndex = self.page;
          self.total = res.mdata.total;
          self.totalPage =
            Math.floor((parseInt(res.mdata.total) - 1) / self.pageSize) + 1;
        })
        .catch(function (response) {
          console.log(response);
        });
    },
    onPreBtnClick() {
      if (this.preBtnDisabled) {
        return;
      }
      this.beginIndex <= this.pageSize && (this.beginIndex = 0);
      this.beginIndex > this.pageSize && (this.beginIndex -= this.pageSize);
      this.queryDeviceList();
    },
    onNextBtnClick() {
      if (this.nextBtnDisabled) {
        return;
      }
      this.beginIndex += this.pageSize;
      this.queryDeviceList();
    },
    resetPreAndNextBtn(length) {
      this.beginIndex == 0 && (this.preBtnDisabled = true);
      this.beginIndex > 0 && (this.preBtnDisabled = false);
      length > this.pageSize && (this.nextBtnDisabled = false);
      length <= this.pageSize && (this.nextBtnDisabled = true);
    },
    onQueryBtnClick() {
      this.beginIndex = 0;
      this.queryDeviceList();
    },
    onPageChooseBtnClick() {
      let index = 0;
      if (this.page <= this.totalPage && this.page > 0) {
        index = this.page;
      } else {
        index = 1;
        this.page = 1;
      }
      this.beginIndex = (index - 1) * this.pageSize;
      this.queryDeviceList();
    },
    onEditBtnClick(data) {
      this.view = "edit";
      this.$nextTick(() => {
        this.editData = data;
      });
    },
    onDetailBtnClick(data) {
      this.view = "detail";
      this.$nextTick(() => {
        let searchCondition = {
          searchCondition: this.searchCondition,
          deviceName: this.deviceName,
          beginIndex: this.beginIndex
        };
        this.editData = data;
        this.editData.searchCondition = searchCondition;
      });
    },
    editSuccessHandle() {
      this.view = "list";
      this.queryDeviceList();
    },
    cancelHandle() {
      this.view = "list";
      this.queryDeviceList();
    },
    addSuccessHandle() {
      this.view = "list";
      this.queryDeviceList();
    }
  }
};
</script>

<style lang="scss" scoped>
.main-body {
  .list {
    line-height: 30px;
    margin: 20px 30px 10px;

    .name-label {
      float: left;
    }

    .value-label {
      display: inline-block;
      height: 30px;
    }

    .date-global {
      width: 185px;
    }

    .list-input {
      width: 180px;
    }
  }

  .table-custom {
    .text-btn {
      width: 50px;
      height: 24px;
      line-height: 24px;
      color: #417505;
      display: inline-block;
      background-color: #bee6b3;
      cursor: pointer;
    }

    .fixed-width-75 {
      width: 75px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/chargeMgmt.vue